import { z } from "zod";

const AddItemToWatchlistStoreSchema = z
  .object({
    id: z.string().uuid({ message: "Id is required." }),
  })
  .strict();

export default AddItemToWatchlistStoreSchema;
